export default "__VITE_ASSET__D_6MoOR$__"